import { styled } from "@styles";
import Link from "next/link";

export const Container = styled(Link, {
  display: "flex",
  alignItems: "center",
  gap: 10,
  textDecoration: "none",

  fontSize: "$14px",
  fontWeight: "$bold",

  color: "$blue40",

  svg: {
    color: "$blue40",
    transition: "color $fast",
  },

  transition: "color $fast",

  "&:not(:disabled):hover": {
    color: "$blue20",

    svg: {
      color: "$blue20",
    },
  },

  "&:disabled": {
    color: "$neutral30",
  },
});
